import { BannerList, CareerListing, FocusedMarketList, NetworkList, NewsList, SolutionList } from "..";
import { APP_ROUTES } from "../../../constants";
import { AppRouteMenuModel } from "../../../models";

export const PageManagementRoutes: AppRouteMenuModel[] = [
  {
    // Banners
    path: APP_ROUTES.PAGEMANAGEMENT.BANNER.BASE,
    title: "Banners",
    renderComponent: () => {
      return <BannerList />;
    },
  },
  {
    // Our Solutions
    path: APP_ROUTES.PAGEMANAGEMENT.SOLUTION.BASE,
    title: "Our Solutions",
    renderComponent: () => {
      return <SolutionList />;
    },
  },
  {
    // News
    path: APP_ROUTES.PAGEMANAGEMENT.NEWS.BASE,
    title: "News",
    renderComponent: () => {
      return <NewsList />;
    },
  },
  // {
  //   // Our Solutions
  //   path: APP_ROUTES.PAGEMANAGEMENT.TECHNOLOGY.BASE,
  //   title: "Our Technology",
  //   renderComponent: () => {
  //     return <TechnologyList />;
  //   },
  // },
  {
    // Focused Market
    path: APP_ROUTES.PAGEMANAGEMENT.FOCUSED_MARKET.BASE,
    title: "Focused Market",
    renderComponent: () => {
      return <FocusedMarketList />;
    },
  },
  {
    // Network
    path: APP_ROUTES.PAGEMANAGEMENT.NETWORK.BASE,
    title: "Network",
    renderComponent: () => {
      return <NetworkList />;
    },
  },
  {
    // Careers
    path: APP_ROUTES.PAGEMANAGEMENT.CAREER.BASE,
    title: "Careers",
    renderComponent: () => {
      return <CareerListing />;
    },
  },
];
